import { IGcpAppDispatch } from "../../../redux/store";
import {
  getDeprecatedUIState,
  getGCPRequestState,
  getModeGcpRequestUiState,
  getRouterState,
  IStoreState,
} from "../../../redux/rootReducer";
import {
  selectActiveNail,
  toggleAllVisibility,
  toggleExistingVisibility,
  toggleProblemVisibility,
  toggleSidebarVisibility,
} from "../../../redux/modules/ui/reducer";
import { invalidateSize } from "../../../map/reusableLayers/NavigationLayer/NavigationLayer";
import { getSuggestedFlightMarkerById } from "../../../redux/modules/gcpRequest/reducer";
import { changeFlightMarkerPlacementStatus } from "../../../redux/modules/gcpRequest/asyncActions";
import config from "../../../config";
import { IGcpAppIo } from "../../../redux/io";
import {
  ACTIVE_FM_CHOSEN_IN_SIDEBAR,
  ACTIVE_FM_ON_THE_MAP_SELECTED,
  ALL_CSV_DOWNLOADED,
  ALL_CSV_WGS_DOWNLOADED,
  ALL_GPX_DOWNLOADED,
  COMPLETE_FM_ON_THE_MAP_SELECTED,
  FM_MARKED_COMPLETE,
  FM_MARKED_INCOMPLETE,
  FM_POPUP_IS_CLOSED,
  REQUESTED_CSV_DOWNLOADED,
  REQUESTED_CSV_WGS_DOWNLOADED,
  REQUESTED_FM_CHOSEN_IN_SIDEBAR,
  REQUESTED_FM_ON_THE_MAP_SELECTED,
  REQUESTED_GPX_DOWNLOADED,
  SHOW_GCP_LABELS_IS_SWITCHED_OFF,
  SHOW_GCP_LABELS_IS_SWITCHED_ON,
  SIDEBAR_CLOSED,
  SUGGESTED_FM_ON_THE_MAP_SELECTED,
  SWITCH_OFF_ACTIVE_FM,
  SWITCH_OFF_EXISTING_FM,
  SWITCH_OFF_REQUESTED_FM,
  SWITCH_ON_ACTIVE_FM,
  SWITCH_ON_EXISTING_FM,
  SWITCH_ON_REQUESTED_FM,
} from "../../../tracking/constants";
import {
  logCSVDownloaded,
  logGPXDownloaded,
} from "../../../redux/modules/metrics/reducer";
import * as download from "downloadjs";
import { toggleGCPFlightMarkerLabels } from "../../../redux/modules/modeGcpRequestUi/reducer";

import { PlacementStatus } from "../../../apiFacades/bapi/gcpRequests";

export const userSelectsActiveFlightMarker =
  (flightMarkerId: string) =>
  (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    trackAction(ACTIVE_FM_CHOSEN_IN_SIDEBAR);
    dispatch(selectActiveNail(flightMarkerId));
    const { allIsVisible } = getDeprecatedUIState(getState());
    if (!allIsVisible) {
      dispatch(toggleAllVisibility());
    }
  };

export const userSelectsRequestedFlightMarker =
  (flightMarkerId: string) =>
  (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    trackAction(REQUESTED_FM_CHOSEN_IN_SIDEBAR);
    dispatch(selectActiveNail(flightMarkerId));
    const { problemIsVisible } = getDeprecatedUIState(getState());
    if (!problemIsVisible) {
      dispatch(toggleProblemVisibility());
    }
  };

export const userTogglesSidebarVisibility =
  () =>
  (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    trackAction(SIDEBAR_CLOSED);
    dispatch(toggleSidebarVisibility());
    dispatch(invalidateSize());
  };

export const userMarksFlightMarkerAsInstalledV2 =
  (flightMarkerId: string) =>
  async (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    trackAction(FM_MARKED_COMPLETE);

    const gcpRequestState = getGCPRequestState(getState());

    const { id, coordinates } = getSuggestedFlightMarkerById(
      gcpRequestState,
      flightMarkerId,
    );

    const { customerId, siteId } = getRouterState(getState()).data;

    await dispatch(
      changeFlightMarkerPlacementStatus(
        customerId,
        siteId,
        id,
        PlacementStatus.COMPLETED,
        coordinates,
      ),
    );
  };

export const userMarksFlightMarkerAsNotInstalledV2 =
  (flightMarkerId: string) =>
  async (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    trackAction(FM_MARKED_INCOMPLETE);

    const { customerId, siteId } = getRouterState(getState()).data;

    await dispatch(
      changeFlightMarkerPlacementStatus(
        customerId,
        siteId,
        flightMarkerId,
        PlacementStatus.UNCOMPLETED,
      ),
    );
  };

// let updateIntervalId: Timeout = null;

export const userOpensGcpRequestViewPage =
  () => async (dispatch: IGcpAppDispatch, getState: () => IStoreState) => {
    // if (updateIntervalId) {
    //   return;
    // }
    // updateIntervalId = setInterval(() => {
    //   const { customerId, siteId, scanDate } = getRouterState(getState()).data;
    //   dispatch(fetchScanGcpRequest(customerId, siteId, scanDate));
    // }, config.installedFlightMarkersUpdateInterval);
  };

export const userLeavesGcpRequestViewPage = () => async () => {
  // if (!updateIntervalId) {
  //   return;
  // }
  // clearInterval(updateIntervalId);
};

export const userTogglesActiveFmVisibility =
  () =>
  async (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    const uiState = getDeprecatedUIState(getState());
    trackAction(
      uiState.allIsVisible ? SWITCH_OFF_ACTIVE_FM : SWITCH_ON_ACTIVE_FM,
    );
    dispatch(toggleAllVisibility());
  };

export const userTogglesExistingFmVisibility =
  () =>
  async (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    const uiState = getDeprecatedUIState(getState());
    trackAction(
      uiState.existingIsVisible
        ? SWITCH_OFF_EXISTING_FM
        : SWITCH_ON_EXISTING_FM,
    );
    dispatch(toggleExistingVisibility());
  };

export const userTogglesProblemFmVisibility =
  () =>
  async (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    const uiState = getDeprecatedUIState(getState());
    trackAction(
      uiState.problemIsVisible
        ? SWITCH_OFF_REQUESTED_FM
        : SWITCH_ON_REQUESTED_FM,
    );
    dispatch(toggleProblemVisibility());
  };

export const userClosesFlightMarkerPopup =
  () =>
  async (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    trackAction(FM_POPUP_IS_CLOSED);
  };

export const userSelectsRequestedFMOnTheMap =
  () =>
  async (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    trackAction(REQUESTED_FM_ON_THE_MAP_SELECTED);
  };

export const userSelectsActiveFMOnTheMap =
  () =>
  async (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    trackAction(ACTIVE_FM_ON_THE_MAP_SELECTED);
  };

export const userSelectsCompleteFMOnTheMap =
  () =>
  async (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    trackAction(COMPLETE_FM_ON_THE_MAP_SELECTED);
  };

export const userSelectsSuggestedFMOnTheMap =
  () =>
  async (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    trackAction(SUGGESTED_FM_ON_THE_MAP_SELECTED);
  };

export const userDownloadsAllCsv =
  (csvFileAll: string) =>
  async (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    trackAction(ALL_CSV_DOWNLOADED);
    // TODO: it might be not really used. so it worth checking
    dispatch(logCSVDownloaded());
    download(
      csvFileAll,
      config.language === "ru" ? "Все_опознаки.csv" : "All_Flight_Markers.csv",
      "text/csv",
    );
  };

export const userDownloadsAllCsvWgs =
  (csvFileAll: string) =>
  async (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    trackAction(ALL_CSV_WGS_DOWNLOADED);
    download(
      csvFileAll,
      config.language === "ru"
        ? "Все_опознаки_WGS84.csv"
        : "All_Flight_Markers_WGS84.csv",
      "text/csv",
    );
  };

export const userDownloadsRequestedCsv =
  (csvFileProblem: string) =>
  async (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    trackAction(REQUESTED_CSV_DOWNLOADED);
    // TODO: it might be not really used. so it worth checking
    dispatch(logCSVDownloaded());
    download(
      csvFileProblem,
      config.language === "ru"
        ? "Запрошенные_опознаки.csv"
        : "Requested_Flight_Markers_Only.csv",
      "text/csv",
    );
  };

export const userDownloadsRequestedCsvWgs =
  (csvFileProblem: string) =>
  async (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    trackAction(REQUESTED_CSV_WGS_DOWNLOADED);
    download(
      csvFileProblem,
      config.language === "ru"
        ? "Запрошенные_опознаки_WGS84.csv"
        : "Requested_Flight_Markers_Only_WGS84.csv",
      "text/csv",
    );
  };

export const userDownloadsAllGpx =
  (gpxFileAll: string) =>
  async (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    trackAction(ALL_GPX_DOWNLOADED);
    dispatch(logGPXDownloaded());
    download(
      gpxFileAll,
      config.language === "ru" ? "Все_опознаки.gpx" : "All_Flight_Markers.gpx",
      "text/csv",
    );
  };

export const userDownloadsRequestedGpx =
  (gpxFileProblem: string) =>
  async (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    trackAction(REQUESTED_GPX_DOWNLOADED);
    dispatch(logGPXDownloaded());
    download(
      gpxFileProblem,
      config.language === "ru"
        ? "Запрошенные_опознаки.gpx"
        : "Requested_Flight_Markers.gpx",
      "text/csv",
    );
  };

export const userClicksShowFlightMarkerLabelsButton =
  () =>
  async (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    const modeGcpRequestUiState = getModeGcpRequestUiState(getState());
    trackAction(
      modeGcpRequestUiState.showFlightMarkerLabelsIsOn
        ? SHOW_GCP_LABELS_IS_SWITCHED_OFF
        : SHOW_GCP_LABELS_IS_SWITCHED_ON,
    );
    dispatch(toggleGCPFlightMarkerLabels());
  };
